import { Space as AntSpace, SpaceProps as AntSpaceProps } from "antd";
import React from "react";

export type SpaceProps = AntSpaceProps & {
  "data-testid"?: string;
};

export type SpaceCompactProps = React.ComponentProps<
  typeof AntSpace.Compact
> & {
  "data-testid"?: string;
};

// Space.Compact provides a wrapper for Ant Design's Space.Compact component,
// maintaining API compatibility while adding our standard test-id support.
// Useful for creating compact button groups, input groups, and other tightly-spaced components.
const Space: React.FC<SpaceProps> & {
  Compact: React.FC<SpaceCompactProps>;
} = ({ children, "data-testid": testId, ...props }) => {
  return (
    <AntSpace {...props} data-testid={testId}>
      {children}
    </AntSpace>
  );
};

const Compact: React.FC<SpaceCompactProps> = ({
  children,
  "data-testid": testId,
  ...props
}) => {
  return (
    <AntSpace.Compact {...props} data-testid={testId}>
      {children}
    </AntSpace.Compact>
  );
};

Space.Compact = Compact;

export default Space;
